// ApiEndpoints.jsx

import React from 'react';

// Utilities
import { formatTimestamp } from '../apiUtils';

// CSS
import './ApiEndpoints.css';

const MAX_VISIBLE_ENDPOINTS = 60;

/**
 * ApiEndpoints
 * 
 * This component renders a list of API endpoints based on the provided OpenAPI schema data. It displays the path, 
 * supported HTTP methods, and summaries for each endpoint. If no endpoints are found, it shows a message prompting 
 * the user to check their API configuration.
 * 
 * @param {array} visibleOpenapiPathRows - An array of objects representing the API paths and their details to be displayed.
 * @param {string} openapiGeneratedAt - A timestamp indicating when the OpenAPI schema was generated, used for display purposes.
 * 
 * @returns {ReactNode} The rendered component displaying the API endpoints.
 */
const ApiEndpoints = ({
  visibleOpenapiPathRows,
  openapiGeneratedAt,
}) => {

  // ----- RENDER ----- //

  return (

    <section className="api-endpoints-container">

      {/* CARD TITLE */}
      <div
        className="api-endpoints-subtitle"
      >
        {visibleOpenapiPathRows.length} documented paths generated at {formatTimestamp(openapiGeneratedAt)}
      </div>

      {/* ENDPOINTS LIST */}
      <div className="api-endpoints-list">

        {visibleOpenapiPathRows.slice(0, MAX_VISIBLE_ENDPOINTS).map((row) => (

          <div
            className="api-endpoints-row"
            key={row.path}
          >

            {/* PATH */}
            <div className="api-endpoints-path">{row.path}</div>

            {/* METHODS */}
            <div className="api-endpoints-methods">
              {(row.methods || []).map((methodRow) => (
                <span
                  className="api-endpoints-chip"
                  key={`${row.path}-${methodRow.method}`}
                >
                  {methodRow.method}
                </span>
              ))}
            </div>

            {(row.methods || []).map((methodRow) => (
              <div
                className="api-endpoints-summary"
                key={`${row.path}-${methodRow.method}-summary`}
              >
                {methodRow.method}: {methodRow.summary || 'No summary'}
              </div>
            ))}
          </div>

        ))}

      </div>

    </section>
  );
};

// Dev Tools
ApiEndpoints.displayName = 'ApiEndpoints';

export default ApiEndpoints;
